import apiClient from './api';

/**
 * Referentiel administrable des types de materiel/vehicule (remplace la
 * liste fermee auparavant codee en dur cote frontend et backend - demande
 * explicite de l'utilisateur : "il faut que le type de materiel soit un
 * referentiel et administrable").
 */
export interface TypeMateriel {
  id: number;
  code: string;
  libelle: string;
  actif: boolean;
}

export interface CreateTypeMaterielDTO {
  code: string;
  libelle: string;
  actif?: boolean;
}

export interface UpdateTypeMaterielDTO {
  // Le code n'est volontairement pas modifiable (cf backend) : deja
  // reference par du materiel/des regles de compatibilite existants.
  libelle?: string;
  actif?: boolean;
}

const BASE_URL = '/types-materiel';

export const typeMaterielService = {
  async list(actifOnly = false): Promise<TypeMateriel[]> {
    const params = actifOnly ? '?actif=true' : '';
    const response = await apiClient.get<TypeMateriel[]>(`${BASE_URL}${params}`);
    return response.data;
  },

  async create(data: CreateTypeMaterielDTO): Promise<TypeMateriel> {
    const response = await apiClient.post<TypeMateriel>(BASE_URL, data);
    return response.data;
  },

  async update(id: number, data: UpdateTypeMaterielDTO): Promise<TypeMateriel> {
    const response = await apiClient.put<TypeMateriel>(`${BASE_URL}/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`${BASE_URL}/${id}`);
  },
};

export default typeMaterielService;
